import { useMemo } from 'react';
import {
  AttributeMappedWidgetDrawerContext,
  AttributeMappedWidgetDrawerProps,
} from './AttributeMappedWidgetDrawerContext';
import { useDocumentFootnotes } from '../../../context/DocumentFootnotesContext';
import WidgetDrawer from '../widget-drawer/WidgetDrawer';

export const AttributeMappedWidgetDrawer = (props: AttributeMappedWidgetDrawerProps) => {
  const { footnotes, documentSourceMap } = useDocumentFootnotes();

  const documentSourceProps = useMemo(
    () => ({
      documentCitations: footnotes,
      documentMetadata: documentSourceMap,
    }),
    [footnotes, documentSourceMap]
  );

  const contextProps = useMemo(() => {
    const {
      attributeMapper,
      attributeReferenceConfig,
      applicationContext,
      handlePushingAttributeMappings,
      handleClearMappings,
      onCitationPushed,
      onReprocessDocument,
      mappingReprocessPrimaryLabel,
      onAcceptAllAIFindings,
      onAcceptAllCitations,
      hasPendingAIFindings,
      hasPendingCitationsForDocument,
      showAcceptAllAI,
      showPushMappings,
    } = props;


    return {
      attributeMapper,
      attributeReferenceConfig,
      applicationContext,
      handlePushingAttributeMappings,
      handleClearMappings,
      onCitationPushed,
      onReprocessDocument,
      mappingReprocessPrimaryLabel,
      onAcceptAllAIFindings,
      onAcceptAllCitations,
      hasPendingAIFindings,
      hasPendingCitationsForDocument,
      showAcceptAllAI,
      showPushMappings,
    };
  }, [props]);

  return (
    <AttributeMappedWidgetDrawerContext.Provider value={contextProps}>
      <WidgetDrawer
        applicationContext={props.applicationContext}
        documentReferencesProps={props.documentReferencesProps}
        documentReferenceHeaderContent={props.documentReferenceHeaderContent}
        documentSourceProps={documentSourceProps}
        notesProps={props.notesProps}
        spreadsheetNotesProps={props.spreadsheetNotesProps}
        documentTabCustomActions={props.documentTabCustomActions}
        documentApplicationStorageKey={props.documentApplicationStorageKey}
      />
    </AttributeMappedWidgetDrawerContext.Provider>
  );
};
